import { render, staticRenderFns } from "./ContextSidebar.vue?vue&type=template&id=84aefd2a&scoped=true&"
import script from "./ContextSidebar.vue?vue&type=script&lang=js&"
export * from "./ContextSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ContextSidebar.vue?vue&type=style&index=0&id=84aefd2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84aefd2a",
  null
  
)

export default component.exports